export default {
    dependencies: [
        '$element',
        'radio',
        'templateservice',
        'trackingservice',
        'userservice',
    ],
    callable(element, radio, templateservice, trackingService, userService) {
        const messagesContainer = element.querySelector(
            '[data-component=messages]'
        );
        const replyWrapper = element.querySelector('[data-reply-wrapper]');
        const conversationWrapper = element.querySelector(
            '[data-conversation-wrapper]'
        );
        const headerWrapper = element.querySelector('[data-header-wrapper]');
        const nextWrapper = element.querySelector('[data-next-wrapper]');
        const previousWrapper = element.querySelector(
            '[data-previous-wrapper]'
        );
        const toolbarWrapper = element.querySelector('[data-toolbar-wrapper]');

        let lastMessageAdded;
        let isScrolledToBottom;

        const selfImageUrl = element.getAttribute('data-user-img');

        init();

        function init() {
            userService.forceRefresh();
            trackingService.trackEventObject({
                analyticsName: 'contact.show-conversation',
                eventFlags: 'start,success',
            });
            setupEvents();
            window.setTimeout(() => {
                scrollToBottom();
                setupInitialVisibility();
            }, 300);
        }

        function setupInitialVisibility() {
            messagesContainer.classList.remove('invisible');
            if (replyWrapper !== null) {
                replyWrapper.classList.remove('invisible');
            }
        }

        function setupEvents() {
            radio('finnbox-reply-focus').subscribe(handleReplyFocus);
            radio('finnbox-reply-success').subscribe(handleReplySuccess);
            radio('finnbox-reply-failure').subscribe(handleReplyFailure);
            radio('finnbox-reply-grow').subscribe(handleReplyGrow);
            radio('finnbox-will-delete').subscribe(handleWillDelete);
            radio('finnbox-cancelled-delete').subscribe(handleCancelDelete);
            radio('finnbox-progress-start').subscribe(handleProgressStart);
            radio('finnbox-progress-end').subscribe(handleProgressEnd);
            radio('safe-trade-open').subscribe(handleSafeTradeStart);
            radio('safe-trade-close').subscribe(handleSafeTradeEnd);
            window.addEventListener(
                'orientationchange',
                handleOrientationChange
            );
            element.addEventListener('scroll', handleScroll);
        }

        function handleReplyFocus() {
            if (messagesContainer.offsetHeight > element.offsetHeight) {
                window.setTimeout(scrollToBottom, 700);
            }
        }

        function handleReplySuccess(data) {
            addMessage(data);
        }

        function handleReplyFailure() {
            scrollToBottom();
        }

        function handleReplyGrow() {
            scrollToBottom();
        }

        function handleSafeTradeStart({ keepHeader = false }) {
            [
                replyWrapper,
                conversationWrapper,
                keepHeader ? null : headerWrapper,
                nextWrapper,
                previousWrapper,
                toolbarWrapper,
            ].forEach(
                wrapperElem =>
                    wrapperElem && wrapperElem.classList.add('hidden')
            );
        }

        function handleSafeTradeEnd() {
            [
                replyWrapper,
                conversationWrapper,
                headerWrapper,
                nextWrapper,
                previousWrapper,
                toolbarWrapper,
            ].forEach(
                wrapperElem =>
                    wrapperElem && wrapperElem.classList.remove('hidden')
            );
            if (isScrolledToBottom) {
                window.setTimeout(scrollToBottom, 20);
            }
        }

        function handleWillDelete() {
            messagesContainer.classList.add('opacity50');
            if (replyWrapper) {
                replyWrapper.classList.add('opacity50');
            }
        }

        function handleCancelDelete() {
            messagesContainer.classList.remove('opacity50');
            if (replyWrapper) {
                replyWrapper.classList.remove('opacity50');
            }
        }

        function handleProgressStart(data) {
            const model = { feedback: data.message, inProgress: true };
            element.innerHTML = templateservice.render(
                'finnbox.conversation_feedback',
                model
            );
        }

        function handleProgressEnd(data) {
            const model = {
                feedback: data.message,
                inProgress: false,
                error: data.error,
            };
            element.innerHTML = templateservice.render(
                'finnbox.conversation_feedback',
                model
            );
        }

        function handleOrientationChange() {
            if (isScrolledToBottom) {
                window.setTimeout(scrollToBottom, 20);
            }
        }

        function handleScroll() {
            const maxScroll =
                messagesContainer.offsetHeight - element.offsetHeight;
            const threshold = maxScroll - 50;
            isScrolledToBottom = element.scrollTop >= threshold;
        }

        function addMessage(message) {
            const messageElement = document.createElement('div');

            messageElement.innerHTML = templateservice.render(
                'finnbox.message',
                {
                    outgoing: true,
                    textLines: message.split('\n'),
                    selfImageUrl,
                    formattedDate: 'for et øyeblikk siden',
                }
            );

            messagesContainer.appendChild(messageElement);
            lastMessageAdded = message;
            scrollToBottom();
        }

        function getLastMessageAdded() {
            return lastMessageAdded;
        }

        function scrollToBottom() {
            window.scrollTo(
                0,
                element.offsetHeight + element.offsetTop - window.innerHeight
            );
            isScrolledToBottom = true;
        }

        return {
            addMessage,
            getLastMessageAdded,
            scrollToBottom,
        };
    },
};



// WEBPACK FOOTER //
// ./controllers/finnboxConversation.js